import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import "./APMSDashboard.scss";

const APMSDashboard = () => {
  const [isRedirected, setIsRedirected] = useState(false);
  const apmsUrl = "https://mdm.pitc.com.pk/api/apms";

  useEffect(() => {
    // Auto open on first load
    const timer = setTimeout(() => {
      window.open(apmsUrl, '_blank');
      setIsRedirected(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const handleOpenAPMS = () => {
    window.open(apmsUrl, '_blank');
  };

  if (isRedirected) {
    return (
      <Box
        className="apms-dashboard"
        sx={{
          height: 'calc(100vh - 100px)',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        <Typography sx={{ color: 'green', fontSize: '16px' }}>
          APMS Dashboard opened in new tab
        </Typography>
        <Button
          variant="contained"
          startIcon={<OpenInNewIcon />}
          onClick={handleOpenAPMS}
          sx={{
            backgroundColor: '#1976d2',
            '&:hover': { backgroundColor: '#1565c0' },
            textTransform: 'none',
            fontSize: '14px',
            padding: '10px 24px'
          }}
        >
          Open APMS Dashboard Again
        </Button>
      </Box>
    );
  }

  return (
    <Box
      className="apms-dashboard"
      sx={{
        height: 'calc(100vh - 100px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
      }}
    >
      <CircularProgress size={50} sx={{ color: '#1976d2' }} />
      <Typography sx={{ color: 'red', fontSize: '16px' }}>
        Redirecting to APMS Dashboard...
      </Typography>
    </Box>
  );
};

export default APMSDashboard;

// import { Box, Typography, CircularProgress, Backdrop, Skeleton, FormControl, Select, MenuItem, IconButton, Tooltip, Modal } from "@mui/material";
// import LightModeIcon from '@mui/icons-material/LightMode';
// import DarkModeIcon from '@mui/icons-material/DarkMode';
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { cfpBaseUrl } from "../../network/urls";
// import { fetchAuth } from "../../features/mdm/authorization";
// import "./APMSDashboard.scss";

// const APMSDashboard = () => {
//   const dispatch = useDispatch();
//   const [viewBackdrop, setViewBackdrop] = useState(false);
//   const [loading, setLoading] = useState(true);

//   // Dark/Light mode state with localStorage persistence
//   const [isDarkMode, setIsDarkMode] = useState(() => {
//     const saved = localStorage.getItem('apms-dashboard-theme');
//     return saved !== null ? JSON.parse(saved) : true;
//   });

//   // Persist theme preference
//   useEffect(() => {
//     localStorage.setItem('apms-dashboard-theme', JSON.stringify(isDarkMode));
//   }, [isDarkMode]);

//   const toggleTheme = () => setIsDarkMode(prev => !prev);
//   const { code, hierarchy } = useSelector((state) => state.auth);

//   // Fetch MDM authorization token on mount
//   useEffect(() => {
//     dispatch(fetchAuth());
//   }, [dispatch]);

//     const { data: mdmToken } = useSelector((state) => state.authorization);

//   const [apmsData, setApmsData] = useState({
//     totalAPMS: 0,
//     aliveAPMS: 0,
//     aliveAPMSGreen: 0,
//     muteAPMS: 0,
//     greyAPMS: 0,
//     criticalAlarms: 0,
//   });

//   // Critical Alarm Data
//   const [criticalAlarmData, setCriticalAlarmData] = useState({
//     overVoltage: 3,
//     underVoltage: 2,
//     overload: 2,
//     voltageUnbalance: 2,
//     currentUnbalance: 4,
//     highApparentPower: 4,
//     residualCurrent: 4,
//   });

//   // MCCB Trip Data
//   const [mccbTripData, setMccbTripData] = useState({
//     overVoltage: 6,
//     underVoltage: 2,
//     overload: 5,
//     voltageUnbalance: 6,
//     currentUnbalance: 5,
//     highApparentPower: 6,
//     residualCurrent: 0,
//   });

//   // Event Status Summary Data (Last 24 Hours)
//   const [eventStatusData, setEventStatusData] = useState({
//     tripping: {
//       totalTrips: 0,
//       clearedTrips: 0,
//       remainingTrips: 0,
//     },
//     alarms: {
//       totalAlarms: 0,
//       clearedAlarms: 0,
//       remainingAlarms: 0,
//     },
//   });

//   // Critical Alarm / Trip Chart Data
//   const [chartPeriod, setChartPeriod] = useState('7days'); // '7days' or '30days'
//   const [alarmTripChartData, setAlarmTripChartData] = useState({
//     categories: ['Feb 19', 'Feb 20', 'Feb 21', 'Feb 22', 'Feb 23', 'Feb 24', 'Feb 25'],
//     critical: [150, 180, 220, 200, 190, 380, 250],
//     trip: [80, 100, 120, 110, 100, 150, 130],
//   });

//   const alarmColors = {
//     overVoltage: "#E91E63",
//     underVoltage: "#FF9800",
//     overload: "#FFEB3B",
//     voltageUnbalance: "#26A69A",
//     currentUnbalance: "#42A5F5",
//     highApparentPower: "#7E57C2",
//     residualCurrent: "#EF5350",
//   };

// // ...existing code...
// const [selectedCriticalAlarm, setSelectedCriticalAlarm] = useState(null);
// const [selectedStatus, setSelectedStatus] = useState('total'); // default 'total' to show all APMS
// const [selectedApmsDetail, setSelectedApmsDetail] = useState(null); // For APMS detail modal
// // ...existing code...

//   const [getData, setGetData] = useState([])

//   // Drill-down states for Circle, Division, Subdivision
//   const [selectedCircle, setSelectedCircle] = useState('');
//   const [selectedDivision, setSelectedDivision] = useState('');
//   const [selectedSubDivision, setSelectedSubDivision] = useState('');
//   const [filteredCircles, setFilteredCircles] = useState([]);
//   const [filteredDivisions, setFilteredDivisions] = useState([]);
//   const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
//   const [selectedOrgCode, setSelectedOrgCode] = useState('');

//   const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions')) || [];

//   useEffect(() => {
//     if (mdmToken?.privatekey && selectedOrgCode) {
//       getAPMSData();
//     }
//   }, [mdmToken, selectedOrgCode]);

//   // Initialize circles for company level users
//   useEffect(() => {
//     // Set initial org code based on hierarchy
//     const initialCode = hierarchy === 1 ? "15" : hierarchy === 2 ? code.slice(0, 2) : hierarchy === 3 ? code.slice(0, 3) : hierarchy === 4 ? code.slice(0, 4) : hierarchy === 52 ? code : "15";
//     setSelectedOrgCode(initialCode);

//     // Only show dropdowns for company level (hierarchy 1 or 2)
//     if ((hierarchy === 1 || hierarchy === 2) && subDivisions.length > 0) {
//       const circles = subDivisions.reduce((acc, curr) => {
//         if (!acc.some(item => item.circleCode === curr.circleCode)) {
//           acc.push({ circleCode: curr.circleCode, circleName: curr.circleName });
//         }
//         return acc;
//       }, []);
//       setFilteredCircles(circles);
//     }
//   }, [hierarchy, code, subDivisions.length]);

//   // Handle Circle change
//   const handleCircleChange = (event) => {
//     const circleCode = event.target.value;
//     setSelectedCircle(circleCode);
//     setSelectedDivision('');
//     setSelectedSubDivision('');
//     setFilteredSubDivisions([]);

//     if (circleCode) {
//       setSelectedOrgCode(circleCode.toString());
//       const uniqueDivisions = subDivisions
//         .filter(item => item.circleCode === parseInt(circleCode))
//         .reduce((acc, item) => {
//           if (!acc.some(division => division.divisionCode === item.divisionCode)) {
//             acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName });
//           }
//           return acc;
//         }, []);
//       setFilteredDivisions(uniqueDivisions);
//     } else {
//       // Reset to company level
//       setSelectedOrgCode(hierarchy === 1 ? "15" : code.slice(0, 2));
//       setFilteredDivisions([]);
//     }
//   };

//   // Handle Division change
//   const handleDivisionChange = (event) => {
//     const divisionCode = event.target.value;
//     setSelectedDivision(divisionCode);
//     setSelectedSubDivision('');

//     if (divisionCode) {
//       setSelectedOrgCode(divisionCode.toString());
//       const uniqueSubDivisions = subDivisions
//         .filter(item => item.divisionCode === parseInt(divisionCode))
//         .reduce((acc, item) => {
//           if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
//             acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName });
//           }
//           return acc;
//         }, []);
//       setFilteredSubDivisions(uniqueSubDivisions);
//     } else {
//       // Reset to circle level
//       setSelectedOrgCode(selectedCircle ? selectedCircle.toString() : (hierarchy === 1 ? "15" : code.slice(0, 2)));
//       setFilteredSubDivisions([]);
//     }
//   };

//   // Handle SubDivision change
//   const handleSubDivisionChange = (event) => {
//     const subDivisionCode = event.target.value;
//     setSelectedSubDivision(subDivisionCode);

//     if (subDivisionCode) {
//       setSelectedOrgCode(subDivisionCode.toString());
//     } else {
//       // Reset to division level
//       setSelectedOrgCode(selectedDivision ? selectedDivision.toString() : selectedCircle ? selectedCircle.toString() : (hierarchy === 1 ? "15" : code.slice(0, 2)));
//     }
//   };

//   const calculateApmsStatus = (data) => {
//     const now = new Date();
//     let aliveCount = 0;
//     let greyCount = 0;
//     let muteCount = 0;

//     data.forEach((item) => {
//       if (!item.last_communication_time) {
//         muteCount++;
//         return;
//       }

//       const lastComm = new Date(item.last_communication_time);
//       const diffHours = (now - lastComm) / (1000 * 60 * 60);

//       if (diffHours <= 3) {
//         aliveCount++;
//       } else if (diffHours > 3 && diffHours <= 6) {
//         greyCount++;
//       } else {
//         muteCount++;
//       }
//     });

//     return { aliveCount, greyCount, muteCount };
//   };

//   const getFilteredApms = () => {
//     if (!selectedStatus || !getData || getData.length === 0) return [];

//     if (selectedStatus === 'total') return getData;

//     const now = new Date();
//     return getData.filter((item) => {
//       if (!item.last_communication_time) {
//         return selectedStatus === 'mute';
//       }

//       const lastComm = new Date(item.last_communication_time);
//       const diffHours = (now - lastComm) / (1000 * 60 * 60);

//       if (selectedStatus === 'alive') return diffHours <= 3;
//       if (selectedStatus === 'grey') return diffHours > 3 && diffHours <= 6;
//       if (selectedStatus === 'mute') return diffHours > 6;

//       return false;
//     });
//   };

//   const formatTimeDiff = (lastCommTime) => {
//     if (!lastCommTime) return 'No communication';
//     const now = new Date();
//     const lastComm = new Date(lastCommTime);
//     const diffMs = now - lastComm;
//     const diffMins = Math.floor(diffMs / (1000 * 60));
//     const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
//     const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

//     if (diffMins < 60) return `${diffMins} min ago`;
//     if (diffHours < 24) return `${diffHours} hr ago`;
//     return `${diffDays} days ago`;
//   };

//   const getAPMSData = () => {
//     if (!mdmToken?.privatekey || !selectedOrgCode) {
//       console.log("MDM token or org code not available yet");
//       return;
//     }
//     setLoading(true);
//     const myHeaders = new Headers();
//     myHeaders.append("Accept", "application/json");
//     myHeaders.append("privatekey", mdmToken.privatekey);

//     const formdata = new FormData();
//     formdata.append("organization_code", selectedOrgCode);

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://api.mdm.pitc.com.pk/api/get_apms_status", requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         const data = result?.data || [];
//         setGetData(data);

//         const { aliveCount, greyCount, muteCount } = calculateApmsStatus(data);

//         setApmsData((prev) => ({
//           ...prev,
//           totalAPMS: result?.apms_total || data.length || 0,
//           aliveAPMSGreen: aliveCount,
//           greyAPMS: greyCount,
//           muteAPMS: muteCount,
//         }));
//       })
//       .catch((error) => console.error("Error fetching APMS data:", error))
//       .finally(() => setLoading(false));
//   }




//   const alarmTypes = [
//     { key: "overVoltage", label: "Over Voltage", color: alarmColors.overVoltage },
//     { key: "underVoltage", label: "Under Voltage", color: alarmColors.underVoltage },
//     { key: "overload", label: "Overload", color: alarmColors.overload },
//     { key: "voltageUnbalance", label: "Voltage Unbalance", color: alarmColors.voltageUnbalance },
//     { key: "currentUnbalance", label: "Current Unbalance", color: alarmColors.currentUnbalance },
//     { key: "highApparentPower", label: "High Apparent Power", color: alarmColors.highApparentPower },
//     { key: "residualCurrent", label: "Residual Current", color: alarmColors.residualCurrent },
//   ];

//   const createChartOptions = (data, title, onPointClick) => ({
//     chart: {
//       type: "pie",
//       backgroundColor: "transparent",
//       height: 200,
//       width: 200,
//       margin: [0, 0, 0, 0],
//     },
//     title: { text: null },
//     credits: { enabled: false },
//     tooltip: {
//       enabled: true,
//       backgroundColor: isDarkMode ? "#1a2942" : "#ffffff",
//       borderColor: isDarkMode ? "#3d5a80" : "#e0e0e0",
//       borderRadius: 8,
//       style: {
//         color: isDarkMode ? "#ffffff" : "#1a2942",
//         fontSize: "12px",
//       },
//       pointFormat: "<b>{point.name}</b>: {point.y}",
//     },
//     plotOptions: {
//       pie: {
//         innerSize: "55%",
//         cursor: "pointer",
//         allowPointSelect: true,
//         dataLabels: {
//           enabled: true,
//           format: "{point.y}",
//           distance: -20,
//           style: {
//             fontSize: "11px",
//             fontWeight: "bold",
//             color: "#ffffff",
//             textOutline: "none",
//           },
//         },
//         borderWidth: 2,
//         borderColor: isDarkMode ? "#1a2942" : "#ffffff",
//         states: {
//           hover: {
//             enabled: true,
//             brightness: 0.1,
//             halo: {
//               size: 10,
//               opacity: 0.25,
//             },
//           },
//           select: {
//             color: null,
//             borderColor: isDarkMode ? "#ffffff" : "#1a2942",
//             borderWidth: 3,
//           },
//         },
//         point: {
//           events: {
//             click: function () {
//               if (onPointClick) {
//                 onPointClick(this.options.key);
//               }
//             },
//           },
//         },
//       },
//     },
//     series: [{
//       name: title,
//       data: alarmTypes.map((alarm) => ({
//         name: alarm.label,
//         y: data[alarm.key] || 0,
//         color: alarm.color,
//         key: alarm.key,
//       })).filter(item => item.y > 0),
//     }],
//   });

//   return (
//     <Box className={`apms-dashboard ${isDarkMode ? 'dark' : 'light'}`}>
//       <Backdrop
//         sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//         open={viewBackdrop}
//       >
//         <CircularProgress color="inherit" />
//       </Backdrop>

//       {(hierarchy === 1 || hierarchy === 2) && (
//         <Box sx={{
//           display: 'flex',
//           gap: '12px',
//           marginBottom: '16px',
//           flexWrap: 'wrap',
//           alignItems: 'center',
//           backgroundColor: isDarkMode ? '#1a2942' : '#ffffff',
//           padding: '12px 16px',
//           borderRadius: '10px',
//           boxShadow: isDarkMode ? 'none' : '0 2px 8px rgba(0,0,0,0.1)',
//         }}>
//           <FormControl size="small" sx={{ minWidth: 180 }}>
//             <Select
//               value={selectedCircle}
//               onChange={handleCircleChange}
//               displayEmpty
//               sx={{
//                 backgroundColor: isDarkMode ? '#0d1b2a' : '#f5f7fa',
//                 color: isDarkMode ? '#fff' : '#1a2942',
//                 '& .MuiSelect-icon': { color: isDarkMode ? '#fff' : '#1a2942' },
//                 '& .MuiOutlinedInput-notchedOutline': { borderColor: isDarkMode ? '#3d5a80' : '#e0e0e0' },
//                 '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#64b5f6' },
//                 '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#64b5f6' },
//               }}
//             >
//               <MenuItem value="">
//                 <em>All Circles</em>
//               </MenuItem>
//               {filteredCircles.map((circle) => (
//                 <MenuItem key={circle.circleCode} value={circle.circleCode}>
//                   {circle.circleName}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {selectedCircle && (
//             <FormControl size="small" sx={{ minWidth: 180 }}>
//               <Select
//                 value={selectedDivision}
//                 onChange={handleDivisionChange}
//                 displayEmpty
//                 sx={{
//                   backgroundColor: isDarkMode ? '#0d1b2a' : '#f5f7fa',
//                   color: isDarkMode ? '#fff' : '#1a2942',
//                   '& .MuiSelect-icon': { color: isDarkMode ? '#fff' : '#1a2942' },
//                   '& .MuiOutlinedInput-notchedOutline': { borderColor: isDarkMode ? '#3d5a80' : '#e0e0e0' },
//                   '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#64b5f6' },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#64b5f6' },
//                 }}
//               >
//                 <MenuItem value="">
//                   <em>All Divisions</em>
//                 </MenuItem>
//                 {filteredDivisions.map((division) => (
//                   <MenuItem key={division.divisionCode} value={division.divisionCode}>
//                     {division.divisionName}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}

//           {selectedDivision && (
//             <FormControl size="small" sx={{ minWidth: 180 }}>
//               <Select
//                 value={selectedSubDivision}
//                 onChange={handleSubDivisionChange}
//                 displayEmpty
//                 sx={{
//                   backgroundColor: isDarkMode ? '#0d1b2a' : '#f5f7fa',
//                   color: isDarkMode ? '#fff' : '#1a2942',
//                   '& .MuiSelect-icon': { color: isDarkMode ? '#fff' : '#1a2942' },
//                   '& .MuiOutlinedInput-notchedOutline': { borderColor: isDarkMode ? '#3d5a80' : '#e0e0e0' },
//                   '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#64b5f6' },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#64b5f6' },
//                 }}
//               >
//                 <MenuItem value="">
//                   <em>All Sub Divisions</em>
//                 </MenuItem>
//                 {filteredSubDivisions.map((subDiv) => (
//                   <MenuItem key={subDiv.subDivisionCode} value={subDiv.subDivisionCode}>
//                     {subDiv.subDivisionName}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}

//           <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px', marginLeft: 'auto' }}>
//             Viewing: <span style={{ color: '#64b5f6', fontWeight: 500 }}>
//               {selectedSubDivision ? 'Sub Division' : selectedDivision ? 'Division' : selectedCircle ? 'Circle' : 'Company'} Level
//             </span>
//           </Typography>
//         </Box>
//       )}

//       <Box className="apms-status-bar">
//         {loading ? (
//           <>
//             {[1, 2, 3, 4, 5].map((item) => (
//               <Box key={item} className="status-card">
//                 <Skeleton variant="text" width={80} height={20} sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
//                 <Skeleton variant="text" width={40} height={32} sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
//               </Box>
//             ))}
//           </>
//         ) : (
//           <>
//             <Box
//               className={`status-card total-purple ${selectedStatus === 'total' ? 'selected' : ''}`}
//               onClick={() => setSelectedStatus(selectedStatus === 'total' ? null : 'total')}
//               sx={{ cursor: 'pointer', border: selectedStatus === 'total' ? '2px solid #7E57C2' : '2px solid transparent' }}
//             >
//               <span className="icon total">📊</span>
//               <span className="label">Total APMS</span>
//               <span className="value">{apmsData.totalAPMS}</span>
//             </Box>

//             <Box
//               className={`status-card alive-green ${selectedStatus === 'alive' ? 'selected' : ''}`}
//               onClick={() => setSelectedStatus(selectedStatus === 'alive' ? null : 'alive')}
//               sx={{ cursor: 'pointer', border: selectedStatus === 'alive' ? '2px solid #4caf50' : '2px solid transparent' }}
//             >
//               <span className="icon check">✓</span>
//               <span className="label">Alive APMS</span>
//               <span className="value">{apmsData.aliveAPMSGreen}</span>
//             </Box>

//             <Box
//               className={`status-card grey-card ${selectedStatus === 'grey' ? 'selected' : ''}`}
//               onClick={() => setSelectedStatus(selectedStatus === 'grey' ? null : 'grey')}
//               sx={{ cursor: 'pointer', border: selectedStatus === 'grey' ? '2px solid #78909c' : '2px solid transparent' }}
//             >
//               <span className="icon grey-dot">●</span>
//               <span className="label">Grey APMS</span>
//               <span className="value">{apmsData.greyAPMS}</span>
//             </Box>

//             <Box
//               className={`status-card mute-blue ${selectedStatus === 'mute' ? 'selected' : ''}`}
//               onClick={() => setSelectedStatus(selectedStatus === 'mute' ? null : 'mute')}
//               sx={{ cursor: 'pointer', border: selectedStatus === 'mute' ? '2px solid #2196f3' : '2px solid transparent' }}
//             >
//               <span className="icon mute">🔇</span>
//               <span className="label">Mute APMS</span>
//               <span className="value">{apmsData.muteAPMS}</span>
//             </Box>



//             <Box className="status-card critical-orange">
//               <span className="icon warning">⚠</span>
//               <span className="label">Critical Alarms</span>
//               <span className="value">{apmsData.criticalAlarms}</span>
//             </Box>

//             {/* Theme Toggle Button */}
//             <Tooltip title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}>
//               <IconButton
//                 onClick={toggleTheme}
//                 sx={{
//                   backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)',
//                   color: isDarkMode ? '#ffd54f' : '#1a2942',
//                   width: '48px',
//                   height: '48px',
//                   borderRadius: '12px',
//                   transition: 'all 0.3s ease',
//                   '&:hover': {
//                     backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.12)',
//                     transform: 'scale(1.05)',
//                   },
//                 }}
//               >
//                 {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
//               </IconButton>
//             </Tooltip>
//           </>
//         )}
//       </Box>

//       <Box className="alarm-cards-row">
//         {loading ? (
//           <>
//             {[1, 2].map((item) => (
//               <Box key={item} className="alarm-card">
//                 <Skeleton variant="text" width={120} height={28} sx={{ bgcolor: 'rgba(255,255,255,0.1)', mb: 2 }} />
//                 <Box className="card-content">
//                   <Skeleton variant="circular" width={180} height={180} sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} />
//                   <Box sx={{ flex: 1, ml: 2 }}>
//                     {[1, 2, 3, 4, 5, 6, 7].map((row) => (
//                       <Skeleton key={row} variant="text" width="100%" height={24} sx={{ bgcolor: 'rgba(255,255,255,0.1)', mb: 0.5 }} />
//                     ))}
//                   </Box>
//                 </Box>
//               </Box>
//             ))}
//           </>
//         ) : (
//           <>
//             <Box className="alarm-card critical-alarm-card">
//               <Typography className="card-title">Critical Alarm</Typography>
//               <Box className="card-content">
//                 <Box className="chart-box">
//                   <HighchartsReact
//                     highcharts={Highcharts}
//                     options={createChartOptions(criticalAlarmData, "Critical Alarm", (key) => {
//                       setSelectedCriticalAlarm(selectedCriticalAlarm === key ? null : key);
//                     })}
//                   />
//                 </Box>
//                 <Box className="alarm-table">
//                   {alarmTypes.map((alarm) => (
//                     <Box
//                       key={alarm.key}
//                       className={`alarm-row ${selectedCriticalAlarm === alarm.key ? 'highlighted' : ''}`}
//                       onClick={() => setSelectedCriticalAlarm(selectedCriticalAlarm === alarm.key ? null : alarm.key)}
//                       style={{
//                         backgroundColor: selectedCriticalAlarm === alarm.key ? `${alarm.color}30` : 'transparent',
//                         borderLeft: selectedCriticalAlarm === alarm.key ? `3px solid ${alarm.color}` : '3px solid transparent',
//                         transition: 'all 0.3s ease',
//                         cursor: 'pointer',
//                         borderRadius: '4px',
//                         padding: '4px 8px',
//                         marginBottom: '2px',
//                       }}
//                     >
//                       <span className="dot" style={{ backgroundColor: alarm.color }}></span>
//                       <span className="name">{alarm.label}</span>
//                       <span className="val">{criticalAlarmData[alarm.key] || 0}</span>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>
//             </Box>

//             <Box className="alarm-card mccb-trip-card">
//               <Typography className="card-title">MCCB Trip</Typography>
//               <Box className="card-content">
//                 <Box className="chart-box">
//                   <HighchartsReact highcharts={Highcharts} options={createChartOptions(mccbTripData, "MCCB Trip")} />
//                 </Box>
//               </Box>
//             </Box>

//             {/* Critical Alarm / Trip Line Chart */}
//             <Box className="alarm-card line-chart-card">
//               <Box className="chart-header">
//                 <Typography className="card-title">Critical Alarm / Trip</Typography>
//                 <Box className="period-toggle">
//                   <span className="summary-label">Summary</span>
//                   <Box className="toggle-buttons">
//                     <button
//                       className={`toggle-btn ${chartPeriod === '7days' ? 'active' : ''}`}
//                       onClick={() => setChartPeriod('7days')}
//                     >
//                       7 Days
//                     </button>
//                     <button
//                       className={`toggle-btn ${chartPeriod === '30days' ? 'active' : ''}`}
//                       onClick={() => setChartPeriod('30days')}
//                     >
//                       30 Days
//                     </button>
//                   </Box>
//                 </Box>
//               </Box>
//               <Box className="line-chart-container">
//                 <HighchartsReact
//                   highcharts={Highcharts}
//                   options={{
//                     chart: {
//                       type: 'line',
//                       backgroundColor: 'transparent',
//                       height: 200,
//                     },
//                     title: { text: null },
//                     credits: { enabled: false },
//                     legend: {
//                       enabled: true,
//                       align: 'center',
//                       verticalAlign: 'bottom',
//                       itemStyle: {
//                         color: isDarkMode ? '#fff' : '#333',
//                         fontSize: '11px',
//                       },
//                     },
//                     xAxis: {
//                       categories: alarmTripChartData.categories,
//                       labels: {
//                         style: { color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px' },
//                       },
//                       lineColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                     },
//                     yAxis: {
//                       title: { text: null },
//                       labels: {
//                         style: { color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px' },
//                       },
//                       gridLineColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                     },
//                     tooltip: {
//                       backgroundColor: isDarkMode ? '#1a2942' : '#fff',
//                       borderColor: isDarkMode ? '#3d5a80' : '#e0e0e0',
//                       style: { color: isDarkMode ? '#fff' : '#333' },
//                     },
//                     plotOptions: {
//                       line: {
//                         marker: {
//                           enabled: true,
//                           radius: 4,
//                         },
//                       },
//                     },
//                     series: [
//                       {
//                         name: 'Critical',
//                         data: alarmTripChartData.critical,
//                         color: '#FFC107',
//                         lineWidth: 2,
//                       },
//                       {
//                         name: 'Trip',
//                         data: alarmTripChartData.trip,
//                         color: '#F44336',
//                         lineWidth: 2,
//                       },
//                     ],
//                   }}
//                 />
//               </Box>
//             </Box>
//           </>
//         )}
//       </Box>

//       {/* APMS Details & Event Status Row */}
//       {!loading && (
//         <Box className="details-event-row" sx={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
//           {/* APMS Details Table - Left Side */}
//           {getData.length > 0 && (
//             <Box
//               className="apms-details-container"
//               sx={{
//                 flex: '2',
//                 minWidth: '500px',
//                 backgroundColor: isDarkMode ? '#1a2942' : '#ffffff',
//                 borderRadius: '12px',
//                 padding: '20px',
//                 boxShadow: isDarkMode ? '0 4px 20px rgba(0, 0, 0, 0.15)' : '0 2px 12px rgba(0,0,0,0.1)',
//               }}
//             >
//               <Box className="details-header" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                   {selectedStatus ? (
//                     <span
//                       style={{
//                         width: '12px',
//                         height: '12px',
//                         borderRadius: '50%',
//                         backgroundColor: selectedStatus === 'total' ? '#7E57C2' : selectedStatus === 'alive' ? '#4caf50' : selectedStatus === 'mute' ? '#2196f3' : '#78909C',
//                       }}
//                     />
//                   ) : (
//                     <span style={{ fontSize: '18px' }}>⚡</span>
//                   )}
//                   <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '16px', fontWeight: 600 }}>
//                     {selectedStatus
//                       ? `${selectedStatus === 'total' ? 'Total' : selectedStatus === 'alive' ? 'Alive' : selectedStatus === 'mute' ? 'Mute' : 'Grey'} APMS (${getFilteredApms().length})`
//                       : 'APMS Details (Communication | Operations)'
//                     }
//                   </Typography>
//                 </Box>
//                 {selectedStatus && (
//                   <Box
//                     onClick={() => setSelectedStatus(null)}
//                     sx={{
//                       cursor: 'pointer',
//                       color: isDarkMode ? '#8892a0' : '#999',
//                       fontSize: '20px',
//                       '&:hover': { color: isDarkMode ? '#fff' : '#333' },
//                     }}
//                   >
//                     ✕
//                   </Box>
//                 )}
//               </Box>

//               <Box
//                 className="details-table"
//                 sx={{
//                   overflowX: 'auto',
//                   overflowY: selectedStatus ? 'auto' : 'visible',
//                   maxHeight: selectedStatus ? '350px' : 'none',
//                   '&::-webkit-scrollbar': { width: '6px', height: '6px' },
//                   '&::-webkit-scrollbar-track': { background: isDarkMode ? '#0d1b2a' : '#f0f0f0' },
//                   '&::-webkit-scrollbar-thumb': { background: isDarkMode ? '#3d5a80' : '#ccc', borderRadius: '3px' },
//                 }}
//               >
//                 <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '500px' }}>
//                   <thead>
//                     <tr style={{ borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}` }}>
//                       <th style={{ textAlign: 'left', padding: '12px 8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px', fontWeight: 600 }}>APMS</th>
//                       <th style={{ textAlign: 'left', padding: '12px 8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px', fontWeight: 600 }}>Status</th>
//                       <th style={{ textAlign: 'left', padding: '12px 8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px', fontWeight: 600 }}>Vendor</th>
//                       <th style={{ textAlign: 'left', padding: '12px 8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px', fontWeight: 600 }}>Active Alarm</th>
//                       <th style={{ textAlign: 'left', padding: '12px 8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px', fontWeight: 600 }}>Last Comm</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(selectedStatus ? getFilteredApms() : getData.slice(0, 6)).map((apms, index) => {
//                       const now = new Date();
//                       const lastComm = apms.last_communication_time ? new Date(apms.last_communication_time) : null;
//                       const diffHours = lastComm ? (now - lastComm) / (1000 * 60 * 60) : 999;
//                       const isAlive = diffHours <= 3;
//                       const isHealthy = apms.current_load && apms.current_load < 0.8;

//                       return (
//                         <tr
//                           key={apms.reference_number || index}
//                           onClick={() => setSelectedApmsDetail(apms)}
//                           style={{
//                             borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}`,
//                             cursor: 'pointer',
//                             transition: 'background-color 0.2s ease',
//                           }}
//                           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'}
//                           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
//                         >
//                           <td style={{ padding: '10px 8px', color: isDarkMode ? '#fff' : '#1a2942', fontSize: '12px' }}>
//                             {apms.reference_number || '-'}
//                           </td>
//                           <td style={{ padding: '10px 8px' }}>
//                             <Box sx={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
//                               <span
//                                 style={{
//                                   display: 'inline-flex',
//                                   alignItems: 'center',
//                                   gap: '3px',
//                                   padding: '2px 6px',
//                                   borderRadius: '3px',
//                                   fontSize: '10px',
//                                   fontWeight: 600,
//                                   backgroundColor: isAlive ? '#4caf50' : '#f44336',
//                                   color: '#fff',
//                                 }}
//                               >
//                                 {isAlive ? '✓' : '✗'} {isAlive ? 'Alive' : 'Dead'}
//                               </span>
//                               <span
//                                 style={{
//                                   display: 'inline-flex',
//                                   alignItems: 'center',
//                                   padding: '2px 6px',
//                                   borderRadius: '3px',
//                                   fontSize: '10px',
//                                   fontWeight: 600,
//                                   backgroundColor: isHealthy ? '#4caf50' : '#ff9800',
//                                   color: '#fff',
//                                 }}
//                               >
//                                 {isHealthy ? 'Healthy' : 'Warning'}
//                               </span>
//                             </Box>
//                           </td>
//                           <td style={{ padding: '10px 8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px' }}>
//                             {apms.vendor || 'Creative Electronics'}
//                           </td>
//                           <td style={{ padding: '10px 8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px' }}>
//                             -
//                           </td>
//                           <td style={{ padding: '10px 8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '11px' }}>
//                             {apms.last_communication_time
//                               ? new Date(apms.last_communication_time).toLocaleString('en-PK', {
//                                   day: '2-digit',
//                                   month: 'short',
//                                   year: 'numeric',
//                                   hour: '2-digit',
//                                   minute: '2-digit',
//                                 })
//                               : '-'}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </Box>
//             </Box>
//           )}

//           {/* Event Status Summary - Right Side */}
//           <Box
//             className="event-status-container"
//             sx={{
//               flex: '1',
//               minWidth: '280px',
//               backgroundColor: isDarkMode ? '#1a2942' : '#ffffff',
//               borderRadius: '12px',
//               padding: '20px',
//               boxShadow: isDarkMode ? '0 4px 20px rgba(0, 0, 0, 0.15)' : '0 2px 12px rgba(0,0,0,0.1)',
//             }}
//           >
//             <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '14px', fontWeight: 600, marginBottom: '16px', textTransform: 'uppercase' }}>
//               EVENT STATUS SUMMARY (LAST 24 HOURS)
//             </Typography>

//             {/* Tripping Section */}
//             <Box sx={{ marginBottom: '16px' }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
//                 <span style={{ fontSize: '14px' }}>⚡</span>
//                 <span style={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '12px', fontWeight: 600 }}>TRIPPING</span>
//               </Box>
//               <Box sx={{ display: 'flex', gap: '8px' }}>
//                 <Box sx={{ flex: 1, backgroundColor: '#2d4a6f', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '9px', fontWeight: 600 }}>TOTAL TRIPS</Typography>
//                   <Typography sx={{ color: '#fff', fontSize: '24px', fontWeight: 800 }}>{eventStatusData.tripping.totalTrips}</Typography>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px' }}>TOTAL TRIPS</Typography>
//                 </Box>
//                 <Box sx={{ flex: 1, backgroundColor: '#2e7d32', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '9px', fontWeight: 600 }}>CLEARED TRIPS</Typography>
//                   <Typography sx={{ color: '#fff', fontSize: '24px', fontWeight: 800 }}>{eventStatusData.tripping.clearedTrips}</Typography>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px' }}>CLEARED TRIPS</Typography>
//                 </Box>
//                 <Box sx={{ flex: 1, backgroundColor: '#c62828', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '9px', fontWeight: 600 }}>Remaining</Typography>
//                   <Typography sx={{ color: '#fff', fontSize: '24px', fontWeight: 800 }}>{eventStatusData.tripping.remainingTrips}</Typography>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px' }}>REMAINING TRIPS</Typography>
//                 </Box>
//               </Box>
//             </Box>

//             {/* Alarms Section */}
//             <Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
//                 <span style={{ fontSize: '14px' }}>⚠</span>
//                 <span style={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '12px', fontWeight: 600 }}>ALARMS</span>
//               </Box>
//               <Box sx={{ display: 'flex', gap: '8px' }}>
//                 <Box sx={{ flex: 1, backgroundColor: '#2d4a6f', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '9px', fontWeight: 600 }}>TOTAL ALARMS</Typography>
//                   <Typography sx={{ color: '#fff', fontSize: '24px', fontWeight: 800 }}>{eventStatusData.alarms.totalAlarms}</Typography>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px' }}>TOTAL ALARMS</Typography>
//                 </Box>
//                 <Box sx={{ flex: 1, backgroundColor: '#2e7d32', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '9px', fontWeight: 600 }}>CLEARED</Typography>
//                   <Typography sx={{ color: '#fff', fontSize: '24px', fontWeight: 800 }}>{eventStatusData.alarms.clearedAlarms}</Typography>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px' }}>CLEARED ALARMS</Typography>
//                 </Box>
//                 <Box sx={{ flex: 1, backgroundColor: '#c62828', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '9px', fontWeight: 600 }}>Remaining</Typography>
//                   <Typography sx={{ color: '#fff', fontSize: '24px', fontWeight: 800 }}>{eventStatusData.alarms.remainingAlarms}</Typography>
//                   <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px' }}>REMAINING ALARMS</Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       )}

//       {/* APMS Detail Modal */}
//       <Modal
//         open={selectedApmsDetail !== null}
//         onClose={() => setSelectedApmsDetail(null)}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//         }}
//       >
//         <Box
//           sx={{
//             backgroundColor: isDarkMode ? '#1a2942' : '#ffffff',
//             borderRadius: '12px',
//             width: '90%',
//             maxWidth: '800px',
//             maxHeight: '85vh',
//             overflow: 'hidden',
//             boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
//             outline: 'none',
//           }}
//         >
//           {selectedApmsDetail && (
//             <>
//               {/* Modal Header */}
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'flex-start',
//                   padding: '16px 20px',
//                   borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
//                   backgroundColor: isDarkMode ? '#0f1c2e' : '#f5f7fa',
//                 }}
//               >
//                 <Box>
//                   <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '16px', fontWeight: 600, marginBottom: '4px' }}>
//                     {selectedApmsDetail.name || 'Unknown APMS'}
//                   </Typography>
//                   <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px' }}>
//                     {new Date().toLocaleString('en-PK', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}
//                   </Typography>
//                 </Box>
//                 <Box
//                   onClick={() => setSelectedApmsDetail(null)}
//                   sx={{
//                     cursor: 'pointer',
//                     color: isDarkMode ? '#8892a0' : '#999',
//                     fontSize: '24px',
//                     '&:hover': { color: isDarkMode ? '#fff' : '#333' },
//                   }}
//                 >
//                   ✕
//                 </Box>
//               </Box>

//               {/* Info Section */}
//               <Box sx={{ padding: '16px 20px', borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}` }}>
//                 <Box sx={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginBottom: '12px' }}>
//                   <Box sx={{ minWidth: '150px' }}>
//                     <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', marginBottom: '2px' }}>MSN</Typography>
//                     <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '13px', fontWeight: 500 }}>{selectedApmsDetail.reference_number || '-'}</Typography>
//                   </Box>
//                   <Box sx={{ minWidth: '150px' }}>
//                     <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', marginBottom: '2px' }}>VENDOR</Typography>
//                     <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '13px', fontWeight: 500 }}>{selectedApmsDetail.vendor || 'Creative Electronics'}</Typography>
//                   </Box>
//                   <Box sx={{ minWidth: '150px' }}>
//                     <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', marginBottom: '2px' }}>SUB DIVISION</Typography>
//                     <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '13px', fontWeight: 500 }}>{selectedApmsDetail.sub_division || '-'}</Typography>
//                   </Box>
//                   <Box sx={{ minWidth: '150px' }}>
//                     <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', marginBottom: '2px' }}>FEEDER</Typography>
//                     <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '13px', fontWeight: 500 }}>{selectedApmsDetail.feeder || '-'}</Typography>
//                   </Box>
//                 </Box>
//                 <Box>
//                   <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', marginBottom: '2px' }}>ADDRESS</Typography>
//                   <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '13px', fontWeight: 500 }}>{selectedApmsDetail.address || 'NO ADDRESS'}</Typography>
//                 </Box>
//               </Box>

//               {/* Metrics Section */}
//               <Box sx={{ padding: '16px 20px', borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}` }}>
//                 <Box sx={{ display: 'flex', gap: '30px', flexWrap: 'wrap' }}>
//                   {/* Load */}
//                   <Box>
//                     <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '11px', marginBottom: '8px', fontWeight: 600 }}>Load</Typography>
//                     <Box sx={{ display: 'flex', gap: '20px' }}>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '9px' }}>KVA</Typography>
//                         <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '13px', fontWeight: 600 }}>{selectedApmsDetail.kva || '-'}</Typography>
//                       </Box>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '9px' }}>KVar</Typography>
//                         <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '13px', fontWeight: 600 }}>{selectedApmsDetail.kvar || '-'}</Typography>
//                       </Box>
//                     </Box>
//                   </Box>

//                   {/* Current */}
//                   <Box>
//                     <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '11px', marginBottom: '8px', fontWeight: 600 }}>Current (Amp)</Typography>
//                     <Box sx={{ display: 'flex', gap: '20px' }}>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '9px' }}>Ia</Typography>
//                         <Typography sx={{ color: '#ffb74d', fontSize: '13px', fontWeight: 600 }}>{selectedApmsDetail.i1 || '-'}</Typography>
//                       </Box>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '9px' }}>Ib</Typography>
//                         <Typography sx={{ color: '#ffb74d', fontSize: '13px', fontWeight: 600 }}>{selectedApmsDetail.i2 || '-'}</Typography>
//                       </Box>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '9px' }}>Ic</Typography>
//                         <Typography sx={{ color: '#ffb74d', fontSize: '13px', fontWeight: 600 }}>{selectedApmsDetail.i3 || '-'}</Typography>
//                       </Box>
//                     </Box>
//                   </Box>

//                   {/* Voltage */}
//                   <Box>
//                     <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '11px', marginBottom: '8px', fontWeight: 600 }}>Voltage (Volt)</Typography>
//                     <Box sx={{ display: 'flex', gap: '20px' }}>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '9px' }}>Va</Typography>
//                         <Typography sx={{ color: '#64b5f6', fontSize: '13px', fontWeight: 600 }}>{selectedApmsDetail.v1 || '-'}</Typography>
//                       </Box>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '9px' }}>Vb</Typography>
//                         <Typography sx={{ color: '#64b5f6', fontSize: '13px', fontWeight: 600 }}>{selectedApmsDetail.v2 || '-'}</Typography>
//                       </Box>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Typography sx={{ color: isDarkMode ? '#8892a0' : '#666', fontSize: '9px' }}>Vc</Typography>
//                         <Typography sx={{ color: '#64b5f6', fontSize: '13px', fontWeight: 600 }}>{selectedApmsDetail.v3 || '-'}</Typography>
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>

//               {/* Recent Events Section */}
//               <Box sx={{ padding: '16px 20px' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
//                   <span style={{ fontSize: '14px' }}>⚡</span>
//                   <Typography sx={{ color: isDarkMode ? '#fff' : '#1a2942', fontSize: '14px', fontWeight: 600 }}>Recent Events</Typography>
//                 </Box>

//                 <Box
//                   sx={{
//                     maxHeight: '200px',
//                     overflowY: 'auto',
//                     '&::-webkit-scrollbar': { width: '6px' },
//                     '&::-webkit-scrollbar-track': { background: isDarkMode ? '#0d1b2a' : '#f0f0f0' },
//                     '&::-webkit-scrollbar-thumb': { background: isDarkMode ? '#3d5a80' : '#ccc', borderRadius: '3px' },
//                   }}
//                 >
//                   <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead>
//                       <tr style={{ borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}` }}>
//                         <th style={{ textAlign: 'left', padding: '8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', fontWeight: 600 }}>Event Time</th>
//                         <th style={{ textAlign: 'left', padding: '8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', fontWeight: 600 }}>Alarm Name</th>
//                         <th style={{ textAlign: 'left', padding: '8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', fontWeight: 600 }}>Severity</th>
//                         <th style={{ textAlign: 'left', padding: '8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '10px', fontWeight: 600 }}>Event Code</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {/* Placeholder events - would come from API */}
//                       <tr style={{ borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}` }}>
//                         <td style={{ padding: '8px', color: isDarkMode ? '#fff' : '#1a2942', fontSize: '11px' }}>
//                           {selectedApmsDetail.last_communication_time ? new Date(selectedApmsDetail.last_communication_time).toLocaleString('en-PK') : '-'}
//                         </td>
//                         <td style={{ padding: '8px', color: isDarkMode ? '#fff' : '#1a2942', fontSize: '11px' }}>Last Communication</td>
//                         <td style={{ padding: '8px' }}>
//                           <span style={{ backgroundColor: '#ff9800', color: '#fff', padding: '2px 8px', borderRadius: '3px', fontSize: '9px', fontWeight: 600 }}>INFO</span>
//                         </td>
//                         <td style={{ padding: '8px', color: isDarkMode ? '#8892a0' : '#666', fontSize: '11px' }}>-</td>
//                       </tr>
//                       <tr style={{ borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}` }}>
//                         <td colSpan={4} style={{ padding: '20px', textAlign: 'center', color: isDarkMode ? '#8892a0' : '#666', fontSize: '12px' }}>
//                           No recent events available
//                         </td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </Box>
//               </Box>
//             </>
//           )}
//         </Box>
//       </Modal>

//     </Box>
//   );
// };

// export default APMSDashboard;

